import React from 'react'
import Theme from '/app/src/theme';

import WelcomeScreen from './WelcomeScreen'
import ModalTemplate from './ModalTemplate'
import ProFeatures from './ProFeatures'
import StartFeatures from './StartFeatures'


const WelcomeModal = ({pricePlan, onClose}) => (
    <ModalTemplate>
        <WelcomeScreen
        {..._getPlanSpec(pricePlan)}
        onClose={onClose}/>
    </ModalTemplate>
)

const _getPlanSpec = (pricePlan) => {
    switch(pricePlan) {
        case 'pro':
            return {
                headerText: 'Välkommen till PRO',
                bodyText: 'Pro är systemet för dig som vill arbeta professionellt med att optimera din service och kundtjänst!',
                features: <ProFeatures/>,
                planImgSrc: '/images/WelcomeGraphic_PRO.png',
                color: Theme.colors.JibberPurple_M

            }
        case 'start':
        default:
            return {
                headerText: 'Välkommen till Start',
                bodyText: 'Start är vår basplan med allt det nödvändiga du behöver för att komma igång med chatt och effektivisera din kundtjänst.',
                features: <StartFeatures/>,
                planImgSrc: '/images/PriceplanGraphic_Start.png',
                color: Theme.colors.JibberBlue_M
            }
    }
}

export default WelcomeModal;



// WEBPACK FOOTER //
// ./src/component/Modal/WelcomeModal/index.js